module.exports = __webpack_public_path__ + "img/item_bg1.52055162.png";